import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetMeMutation } from '@services/core/auth/auth.endpoints';
import { logout } from '@features/auth/auth.slice';
import { setValidationCount } from '@features/menu/menu.slice';
import { useLocation } from 'react-router-dom';
import { useGetMemberValidationsCountQuery } from '@services/member/member-validation/member-validation.endpoints';

export const useAuthentifiedLayout = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();

    // Get Me
    const [getMe, getMeResults] = useGetMeMutation();

    // Get Member Validations Count with polling every 30 seconds
    const { data: validationCount } = useGetMemberValidationsCountQuery(undefined, {
        pollingInterval: 600000, // Poll every 10 minutes
        refetchOnMountOrArgChange: true
    });

    useEffect(() => {
        if (!getMe) return;
        getMe(undefined);
    }, [getMe, pathname]);

    useEffect(() => {
        if (!getMeResults) return;
        if (getMeResults.isError) {
            dispatch(logout());
        }
    }, [getMeResults, dispatch]);

    // Update validation count in Redux when it changes
    useEffect(() => {
        if (validationCount !== undefined) {
            dispatch(setValidationCount({ count: validationCount }));
        }
    }, [validationCount, dispatch]);

    return {};
};
